// A whitelist: any field missing here is dropped before the table sees it.
export const buildPaymentRow = (item) => ({
  id: item?._id,
  dueDate: item?.dueDate,
  pmt: item?.pmt,
  amount: item?.amount,
  status: item?.status?.label,
  frequency: item?.frequency,
  reason: item?.reason,
  statusObj: item?.status,
  statusId: item?.status?._id,
  type: item?.type?.label,
  transactionId: item?.transactionId,
  transactionData: item?.transactionData,
  billingAccount: item?.billingAccount?.billingAccountType,
  billingAccountId: item?.billingAccount?._id,
  created: item?.createdAt,
  createdBy: `${item?.createdBy?.firstName} ${item?.createdBy?.lastName}`,
  billingAccountLast4: item?.billingAccount?.accountNumberLast4 || item?.billingAccount?.cardNumberLast4,
  amountPaid: item?.amountPaid,
  settledByPayment: item?.settledByPayment,
  settledAt: item?.settledAt,
  settlesPayments: item?.settlesPayments,
  // WS 2074858: a rescheduled declined payment names its attempt and the attempt it replaces.
  attempt: item?.attempt,
  rescheduledFrom: item?.rescheduledFrom,
})
